import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=068e2b88&scoped=true&"
import script from "./Business.vue?vue&type=script&lang=js&"
export * from "./Business.vue?vue&type=script&lang=js&"
import style0 from "./Business.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Business.vue?vue&type=style&index=1&id=068e2b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e2b88",
  null
  
)

export default component.exports